import { createMulticall } from '@uniswap/redux-multicall'
import useActiveWeb3 from 'hooks/blockchain/useActiveWeb3'
import useBlockNumber from 'hooks/blockchain/useBlockNumber'
import { useInterfaceMulticall } from 'hooks/blockchain/useContract'
import { combineReducers, createStore } from 'redux'

const multicall = createMulticall()
const reducer = combineReducers({ [multicall.reducerPath]: multicall.reducer })
export const store = createStore(reducer)

export default multicall

export function MulticallUpdater() {
  const latestBlockNumber = useBlockNumber()
  const { networkId } = useActiveWeb3()
  const contract = useInterfaceMulticall()
  return <multicall.Updater chainId={networkId} latestBlockNumber={latestBlockNumber} contract={contract} />
}
